import { Navigate } from 'react-router';

import { ANY_SPORT_PLAY_EVENTTYPE } from '@sorare/core/src/constants/__generated__/routes';
import { useSportContext } from '@sorare/core/src/contexts/sport';

import { useLastVisitedEventType } from 'hooks/useLastVisitedEventType';

export const PlayPage = () => {
  const { generateSportContextPath } = useSportContext();
  const { lastVisitedEventType } = useLastVisitedEventType();

  return (
    <Navigate
      to={generateSportContextPath(ANY_SPORT_PLAY_EVENTTYPE, {
        params: {
          eventType: lastVisitedEventType,
        },
      })}
      replace
    />
  );
};

export default PlayPage;
